import React from 'react';
import { PeriodControlView } from './PeriodControlView';
import { usePeriodControl } from './usePeriodControl';

/**
 * Sales-page date-range filter. Container wires {@link usePeriodControl}
 * (URL ↔ provider sync + shortcut state) into the render-only
 * `PeriodControlView`. Reads/writes its range through the page-level
 * `SalesProvider` so every widget sees the same filter without prop-drilling.
 */
export const PeriodControl: React.FC = () => {
    const vm = usePeriodControl();

    return <PeriodControlView {...vm} />;
};
